import type zh from '../zh/skills';

/** Skill marketplace and Cheetah, English. Typed against the zh file so a missing key fails tsc. */
const skills: typeof zh = {
  hero: {
    title: "Rocky's Armory",
    count: '<highlight>{{n}} Skills</highlight> are now available!',
    imageAlt: "Rocky's Armory characters",
  },
  tabs: {
    recommend: 'Recommend',
    mySkills: 'My Skills',
  },
  categories: {
    dataretriever: 'Retrieve and aggregate data from multiple sources.',
    hedwig: 'Automate messaging workflows and notification delivery.',
    cheetah:
      'Internal expert booking service — match the right person to your needs, one-click booking and track the entire engagement workflow.',
    ivt: 'Industry vertical solutions — explore solution maps, storylines, assets and motions to power vertical selling.',
    campaign_copilot: 'Campaign orchestration — audience segmentation, personalized emails, Octopus program creation and performance analytics.',
    event_insights: 'Event insights — pre- and post-event data reports.',
  },
  search: 'Find skill',
  loading: 'Loading skills...',
  loadFailed: 'Failed to load skills: {{message}}',
  empty: 'No skills found.',
  untitled: 'Untitled',
  generalTag: 'General',
  card: {
    showDetails: 'Show Details',
  },
  modal: {
    close: 'Close',
    noDescription: 'No description available.',
    noPreview: 'Preview not available',
    cancel: 'Cancel',
    processing: 'Processing...',
    equip: 'Equip Skill',
    unequip: 'Unequip Skill',
  },
  cheetah: {
    back: 'Back to Workspace',
    introLabel: 'Cheetah introduction',
    intro:
      'Want a senior technologist to join your customer visit? Cheetah offers a standard expert-booking service: match the right expert to your needs, book online and follow the visit through.',
    revisit: 'Book a follow-up',
    book: 'Book now',
    revisitPrompt: 'I want to arrange a follow-up visit.',
    bookPrompt: 'I want to book a tech expert to visit a customer.',
    expertsLabel: 'Tech experts',
    expertTitle: 'External Title: {{title}}',
    phoneTool: '{{name}} PhoneTool',
    modalTitle: 'Expert Information',
    modalLabel: 'Expert Information',
    close: 'Close',
  },
};

export default skills;
